import { Badge } from "@devhop/ui";
import type { FormStatus } from "@/server/platform/db/schema/forms";

export function FormStatusBadge({ status }: { status: FormStatus }) {
  const label =
    status === "draft" ? "ຮ່າງ" : status === "published" ? "ເປີດຮັບ" : "ປິດແລ້ວ";

  const variant =
    status === "published"
      ? "default"
      : status === "closed"
        ? "outline"
        : "secondary";

  return <Badge variant={variant}>{label}</Badge>;
}
